import React from "react";
import Select from "components/Form/fields/Select";
import { TOP_CONTROL } from "utils/styles";
// import ProductActions from "components/FormerPricingTable/ProductActions";

/**
 * Mobile select menu
 */
const ProductFeaturesTableHeader = ({
  product,
  options,
  activeIndex,
  setActiveIndex
}) => {
  const { formattedPrice, actions } = product;

  const selectProps = {
    options,
    value: activeIndex,
    disabled: options.length <= 1,
    onChange: () => (evt) => {
      const selection = evt.currentTarget.value;
      setActiveIndex(parseInt(selection));
    },
    labelTransform: (val) => val,
    customClasses: {
      input: "border-box input-reset ba b--black-20 pa2 mb0 db w-100 pv2 f5 br2"
    }
  };
  return (
    <div
      className="product-picker-header w-100 sticky pv2 pv3-ns bg-white bb bt hairline-1"
      style={{ top: TOP_CONTROL }}
    >
      <div className="f5 w-100 ph3 pb2 pb3-ns">
        <div className="f3 fw6 pb3 pt2">Provider</div>
        <Select {...selectProps} />
      </div>
      <div className="flex flex-row w-100 items-center justify-center pv1">
        <div className="flex items-start pl3">
          {/* <ProductActions
            customClasses={{
              container: "relative center lh-copy w-100 pv0"
            }}
            actions={actions}
            theme="slim"
            productIndex={activeIndex}
            isEmphasized={true}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default ProductFeaturesTableHeader;
